import {IComponentOptions, ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";

class InfoModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    private title: string;
    private content: string;

    /* @ngInject */
    constructor(private $log: ILogService) {}

    public $onInit() {
        this.title = this.resolve.title;
        this.content = this.resolve.content;
    }


    public closeModal() {
        this.dismiss({$value: "cancel"});
    }

}

export const InfoModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: InfoModalController,
    template: require("./info-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/info-modal/info-modal.component.ts